import { PaymentType } from '~/common/enums/payments.enum';
import { CardType } from '~/services/wallet/interfaces/wallets.interface';

export const paymentTypeOptions = [
  PaymentType.AEROPAY,
  PaymentType.CARD,
  PaymentType.VIPPREFERRED,
  PaymentType.PAYPAL,
  PaymentType.PAPER_CHECK,
  PaymentType.VENMO,
  PaymentType.SKRILL,
];

// WHOP_CRYPTO, WIRE and EDGE_BOOST are deposit-only, so they cannot live in paymentTypeOptions
export const DEPOSIT_ONLY_PAYMENT_TYPES: PaymentType[] = [
  PaymentType.WIRE,
  PaymentType.EDGE_BOOST,
  PaymentType.WHOP_CRYPTO,
];

export const depositPaymentTypeOptions = [...paymentTypeOptions, ...DEPOSIT_ONLY_PAYMENT_TYPES];

// Wires under this amount are returned by the bank
export const WIRE_DEPOSIT_MINIMUM = 10_000;

export const SELF_FRAMED_PAYMENT_TYPES: PaymentType[] = [
  PaymentType.AEROPAY,
  PaymentType.CARD,
  PaymentType.WHOP,
  PaymentType.EDGE_BOOST,
  PaymentType.WHOP_CRYPTO,
];

export const EDGE_BOOST_URL = 'https://edgeboost.io/splash';
export const EDGE_BOOST_DISPLAY_URL = EDGE_BOOST_URL.replace(/^https:\/\//, '');

export const EDGE_BOOST_TILE_ICON_SIZE = 12;

export const DEFAULT_ICON_SLOT = { width: 36, size: 20 };

export const PAYMENT_TYPE_ICON_SLOT: Partial<Record<PaymentType, typeof DEFAULT_ICON_SLOT>> = {
  [PaymentType.AEROPAY]: { width: 76, size: 10 },
  [PaymentType.EDGE_BOOST]: { width: 44, size: EDGE_BOOST_TILE_ICON_SIZE },
};

export const cardTypeToTitle = {
  [CardType.VI]: 'Visa',
  [CardType.MC]: 'Mastercard',
  [CardType.AM]: 'American Express',
  [CardType.DI]: 'Discover',
};

export const AEROPAY_WIDGET_ID = 'aeropay-widget';

export const MAX_AEROPAY_ACCOUNTS = 5;

// Refundable balance consistency checking
export const MAX_CONSISTENCY_RETRIES = 1;
